var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 36.6667H16.6667M63.3333 36.6667C65.1014 36.6667 66.7971 37.369 68.0474 38.6193C69.2976 39.8695 70 41.5652 70 43.3333V63.3333C70 65.1014 69.2976 66.7971 68.0474 68.0474C66.7971 69.2976 65.1014 70 63.3333 70H16.6667C14.8986 70 13.2029 69.2976 11.9526 68.0474C10.7024 66.7971 10 65.1014 10 63.3333V43.3333C10 41.5652 10.7024 39.8695 11.9526 38.6193C13.2029 37.369 14.8986 36.6667 16.6667 36.6667M63.3333 36.6667V30C63.3333 28.2319 62.631 26.5362 61.3807 25.286C60.1305 24.0357 58.4348 23.3333 56.6667 23.3333M16.6667 36.6667V30C16.6667 28.2319 17.369 26.5362 18.6193 25.286C19.8695 24.0357 21.5652 23.3333 23.3333 23.3333M56.6667 23.3333V16.6667C56.6667 14.8986 55.9643 13.2029 54.714 11.9526C53.4638 10.7024 51.7681 10 50 10H30C28.2319 10 26.5362 10.7024 25.286 11.9526C24.0357 13.2029 23.3333 14.8986 23.3333 16.6667V23.3333M56.6667 23.3333H23.3333",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.e2e83547a568f42ca89ad60cb79d3d52.svg";
export { ForwardRef as ReactComponent };